import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full"
}
const _hoisted_2 = { class: "flex md:gap-x-1 flex-wrap mb-2 w-full justify-center" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "h-12 w-13 md:h-12 md:w-15 rounded-2xl bg-white overflow-hidden relative flex items-center justify-center" }
const _hoisted_5 = ["src", "srcset"]
const _hoisted_6 = { class: "text-parameter-text text-[10px] overflow-hidden max-w-13 md:max-w-15 mx-auto text-center mt-1" }
const _hoisted_7 = {
  key: 0,
  class: "border-l border-l-[#e7ddcc] pl-2 relative flex flex-col items-center py-2 px-1 hover:bg-[#f3f0e9]"
}
const _hoisted_8 = { class: "h-12 w-13 md:h-12 md:w-15 rounded-2xl bg-white overflow-hidden relative flex items-center justify-center" }
const _hoisted_9 = ["src", "srcset"]
const _hoisted_10 = { class: "text-parameter-text text-[10px] overflow-hidden max-w-14 mx-auto text-center mt-1" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "h-12 w-13 md:h-12 md:w-15 rounded-2xl bg-white overflow-hidden relative flex items-center justify-center" }
const _hoisted_13 = ["src", "srcset"]
const _hoisted_14 = { class: "text-parameter-text text-[10px] overflow-hidden max-w-13 md:max-w-15 mx-auto text-center mt-1" }

import {computed, inject, ref, watch} from "vue";
import {mapActions, useStore} from "vuex";
import {ParametersVariations} from "@/assets/ts/parametersVariations";
import ItemV3StonesParameterLoading from "@/components/itemV3/parameter/stones/parameter/itemV3StonesParameterLoading.vue";

const variantIdx = ""


export default /*@__PURE__*/_defineComponent({
  __name: 'itemV3StonesSetting',
  props: {
    groupIdx: {},
    presetButton: { type: Boolean, default: true },
    prioSettings: {},
    stoneLayout: { default: "single" }
  },
  emits: ["patch", "show-presets"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;

const store = useStore();

const loadItemVariants = inject<any>("loadItemVariants");

const itemIdx = inject<any>("itemIdx");
const session = inject<any>("session");

/**
 * session
 *
 * Transferred from itemV3DiscsRatio.vue: configureAll/itemIdx are wired into
 * ParametersVariations the same way, but - like itemV3StonesStoneSize.vue /
 * itemV3StonesPosition.vue - the variant is fetched per stone group via
 * getItemVariants(itemIdx, "stones.<groupIdx>.stone_setting") instead of a fixed idx.
 */

const configureAll = computed(() => store.getters["session/getConfigureAll"])
const parametersVariations = new ParametersVariations(variantIdx, configureAll, session, itemIdx, loadItemVariants)

/**
 * stone setting - stones.<groupIdx>.stone_setting
 */

const stoneSetting = ref({
  "stone_setting": {}
} as any)

const getStoneSettingData = (groupIdy: number) => {
  if (groupIdy >= 0) {
    stoneSetting.value.stone_setting = parametersVariations.getItemVariants(itemIdx.value, "stones." + groupIdy + ".stone_setting")
  }
}

watch(() => props.groupIdx, (groupIdy) => {
  getStoneSettingData(groupIdy)
}, {immediate: true})

watch(session, () => {
  getStoneSettingData(props.groupIdx)
}, {deep: true})

/**
 * setting variants (transferred from itemV3DiscsRatio.vue's "color variants")
 */

const active = computed(() => {
  return stoneSetting.value.stone_setting[0]
})

const variantsList = computed(() => active.value?.values || [])

const matchedIdx = computed(() => variantsList.value.findIndex((v: any) => v.match))

/*
 * focus values (transferred from itemV3DiscsRatio.vue's "focus values")
 */

const focusValueIdx = props.prioSettings || [
  // idx must match one of the stone_setting option keys (see locales/*.json)
  "CHANNEL",
  "PAVE",
  "BEZEL"
]

const getFocusValueIdx = computed(() => {
  if (matchedIdx.value !== -1 && !focusValueIdx.includes(variantsList.value[matchedIdx.value].idx)) {
    return [
      variantsList.value[matchedIdx.value].idx,
      ...focusValueIdx.slice(0, -1)
    ]
  }

  return focusValueIdx
})

// only the values that are part of focusValueIdx should ever be shown; if that list is
// larger than 5, the first 5 are shown directly and the rest are hidden behind "more"
const focusVariantsList = computed(() => getFocusValueIdx.value
    .map((idx: string) => variantsList.value.find((v: any) => v.idx === idx))
    .filter((v: any) => !!v))

const visibleFocusValues = computed(() => focusVariantsList.value.slice(0, 20))

const moreFocusValues = computed(() => focusVariantsList.value.slice(20))

const hasMoreValues = computed(() => moreFocusValues.value.length > 0)

// whether the "more" values (list entry with the right-arrow) have been revealed inline
const showMore = ref(false)

/**
 * Patch
 */

const handleValuePatch = (actionIdx: string, value: any) => {
  emit('patch', {
    action: actionIdx,
    value: value.idx,
    certificated_diamond: value.certificated_diamond
  });
};

/**
 * Stone addon
 */

const hasStoneAddon = computed(() => {
  // if in session.value.items[itemIdx.value].variants an object exist with idx = "stones.<props.groupIdx>.stone_addon" and key != ""
  const addon = getStoneAddon.value
  return Boolean(addon && addon.key && addon.key !== "")
})

const getStoneAddon = computed(() => {
  if (session.value?.items?.[itemIdx.value]?.variants) {
    const variants = session.value.items[itemIdx.value].variants
    const list = Array.isArray(variants) ? variants : Object.values(variants)
    return list.find((v: any) => v?.idx === `stones.${props.groupIdx}.stone_addon`) || {}
  }
  return {}
})

/**
 * stone setting
 */

const stoneSettingUrlAddon = computed(() => {
  return (props.stoneLayout !== "single") ? "-" + props.stoneLayout : ""
})

const newIcons = [
  "c391",
  "c281",
  "c66",
  "c31",
  "c22",
  "c21",
  "c18",
  "c17",
  "c5"
]

// true if the currently selected stone addon is one of the "new icon" addons
const useNewIcons = computed(() => {
  const key = getStoneAddon.value?.key
  return !!key && newIcons.includes(String(key).toLowerCase())
})



return (_ctx: any,_cache: any) => {
  return (active.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleFocusValues.value, (variantData, variantIdx) => {
            return (_openBlock(), _createElementBlock("li", {
              key: variantIdx,
              class: _normalizeClass(["cursor-pointer flex flex-col items-center py-2 px-1 rounded-2xl hover:bg-[#f3f0e9]", {
              'border-2 border-brand-main bg-[#f3f0e9]': variantData.match,
              'border-2 border-transparent': !variantData.match
            }]),
              onClick: ($event: any) => (handleValuePatch(active.value.idx, variantData))
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/stone_setting/400x300/${variantData.idx.toLowerCase()}${stoneSettingUrlAddon.value}.webp`,
                  srcset: `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/stone_setting/800x600/${variantData.idx.toLowerCase()}${stoneSettingUrlAddon.value}.webp`,
                  class: "w-full h-full object-cover relative"
                }, null, 8, _hoisted_5)
              ]),
              _createElementVNode("span", _hoisted_6, _toDisplayString(variantData.title), 1)
            ], 10, _hoisted_3))
          }), 128)),
          (hasStoneAddon.value)
            ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                _createElementVNode("button", {
                  class: "absolute top-0 right-0 p-1 rounded-full hover:bg-white hover:text-brand-main z-10 bg-brand-main text-white cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (handleValuePatch(getStoneAddon.value.idx, {idx: ''})))
                }, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    "stroke-width": "1.5",
                    stroke: "currentColor",
                    class: "w-4 h-4"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                    })
                  ], -1)
                ]))]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("img", {
                    src: useNewIcons.value
                ? `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/stone_addon/400x300/${getStoneAddon.value.key.toLowerCase()}.webp`
                : `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/stone_addon/300x300/addon_${getStoneAddon.value.key.toLowerCase()}.webp`,
                    srcset: useNewIcons.value
                ? `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/stone_addon/800x600/${getStoneAddon.value.key.toLowerCase()}.webp`
                : `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/stone_addon/600x600/addon_${getStoneAddon.value.key.toLowerCase()}.webp`,
                    class: "w-full h-full object-cover relative"
                  }, null, 8, _hoisted_9)
                ]),
                _createElementVNode("span", _hoisted_10, _toDisplayString(getStoneAddon.value.text), 1)
              ]))
            : _createCommentVNode("", true),
          (hasMoreValues.value && !showMore.value)
            ? (_openBlock(), _createElementBlock("li", {
                key: 1,
                class: "cursor-pointer flex flex-col items-center py-2 px-1 rounded-2xl hover:bg-[#f3f0e9] border-2 border-transparent",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showMore.value = true))
              }, [...(_cache[5] || (_cache[5] = [
                _createElementVNode("div", { class: "h-12 w-12 md:h-12 md:w-15 rounded-2xl flex items-center justify-center relative bg-[#f3f0e9]" }, [
                  _createElementVNode("svg", {
                    "aria-hidden": "true",
                    viewBox: "0 0 12 12",
                    fill: "none",
                    class: "size-2.5 shrink-0 -rotate-90 text-[#555956]"
                  }, [
                    _createElementVNode("path", {
                      d: "m1.5 4 4.5 4 4.5-4",
                      stroke: "currentColor",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ])
                ], -1),
                _createElementVNode("span", { class: "text-parameter-text text-[10px] overflow-hidden max-w-12 mx-auto text-center mt-1" }, " Mehr ", -1)
              ]))]))
            : _createCommentVNode("", true),
          (showMore.value)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(moreFocusValues.value, (variantData, variantIdx) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: 'more-' + variantIdx,
                  class: _normalizeClass(["cursor-pointer flex flex-col items-center py-2 px-1 rounded-2xl hover:bg-[#f3f0e9]", {
              'border-2 border-brand-main bg-[#f3f0e9]': variantData.match,
              'border-2 border-transparent': !variantData.match
            }]),
                  onClick: ($event: any) => (handleValuePatch(active.value.idx, variantData))
                }, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("img", {
                      src: `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/stone_setting/400x300/${variantData.idx.toLowerCase()}${stoneSettingUrlAddon.value}.webp`,
                      srcset: `https://images-api-prod-images.s3.eu-central-1.amazonaws.com/parts/parameters/stone_setting/800x600/${variantData.idx.toLowerCase()}${stoneSettingUrlAddon.value}.webp`,
                      class: "w-full h-full object-cover relative"
                    }, null, 8, _hoisted_13)
                  ]),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(variantData.title), 1)
                ], 10, _hoisted_11))
              }), 128))
            : _createCommentVNode("", true),
          (showMore.value)
            ? (_openBlock(), _createElementBlock("li", {
                key: 3,
                class: "cursor-pointer flex flex-col items-center py-2 px-1 rounded-2xl hover:bg-[#f3f0e9] border-2 border-transparent",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (showMore.value = false))
              }, [...(_cache[6] || (_cache[6] = [
                _createElementVNode("div", { class: "h-12 w-13 md:h-12 md:w-15 rounded-2xl flex items-center justify-center relative bg-[#f3f0e9]" }, [
                  _createElementVNode("svg", {
                    "aria-hidden": "true",
                    viewBox: "0 0 12 12",
                    fill: "none",
                    class: "size-2.5 shrink-0 rotate-90 text-[#555956]"
                  }, [
                    _createElementVNode("path", {
                      d: "m1.5 4 4.5 4 4.5-4",
                      stroke: "currentColor",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ])
                ], -1),
                _createElementVNode("span", { class: "text-parameter-text text-[10px] overflow-hidden max-w-13 md:max-w-15 mx-auto text-center mt-1" }, " Weniger ", -1)
              ]))]))
            : _createCommentVNode("", true),
          (__props.presetButton)
            ? (_openBlock(), _createElementBlock("li", {
                key: 4,
                class: "cursor-pointer flex flex-col items-center py-2 px-1 rounded-2xl hover:bg-[#f3f0e9] border-2 border-transparent",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('show-presets')))
              }, [...(_cache[7] || (_cache[7] = [
                _createStaticVNode("<div class=\"h-12 w-13 md:h-12 md:w-15 rounded-2xl flex items-center justify-center relative bg-[#f3f0e9]\"><svg aria-hidden=\"true\" viewBox=\"0 0 16 16\" fill=\"none\" class=\"size-4 shrink-0 text-[#555956]\"><circle cx=\"3\" cy=\"8\" r=\"1.5\" fill=\"currentColor\"></circle><circle cx=\"8\" cy=\"8\" r=\"1.5\" fill=\"currentColor\"></circle><circle cx=\"13\" cy=\"8\" r=\"1.5\" fill=\"currentColor\"></circle></svg></div><span class=\"text-parameter-text text-[10px] overflow-hidden max-w-13 md:max-w-15 mx-auto text-center mt-1\"> Andere </span>", 2)
              ]))]))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createBlock(ItemV3StonesParameterLoading, { key: 1 }))
}
}

})